// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { displayPieChartStyles } from "@steiner/App/Widgets/AccountSummary/DisplayPieChart";
import { color } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

displayPieChartStyles.container = {
    css: css`
        display: flex;
        gap: 8px;
    `,
};

displayPieChartStyles.infoContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

displayPieChartStyles.infoTextContainer = {
    css: css`
        position: relative;
        padding-left: 16px;
        display: flex;
        flex-direction: column;
        gap: 4px;
        &:after {
            position: absolute;
            content: " ";
            left: 0;
            top: 4px;
            width: 8px;
            height: 8px;
            ${({ itemColor }: any) => css`
                background: ${color(itemColor)};
            `}
            border-radius: 2px;
        }
    `,
};
